query palette {
  brickPalette {
    colour
    identifier
  }
}
